import { AdvertErrorBoundary } from 'components/advert/advert-error-boundary.js';
import { ColumnLayoutContext } from 'page-context/column-layout/column-layout-context.js';
import { CSSProperties, useContext, useRef } from 'react';
import { IMeasuredAdConfig } from 'redux-state/advertisement/types.js';
import { AdDomReadyContext } from 'routing/main-3-ads-ready-provider.js';
import { isNullOrUndefined } from 'utilities/isType.js';
import { AdvertFuse } from './advert-fuse.js';

const DEFAULT_HEADER_BANNER_HEIGHT = 250;

const getDefaultBannerHeight = (banner: IMeasuredAdConfig | undefined, isMobile: boolean) => {
  const height = isMobile ? banner?.mobileHeight : banner?.height;
  if (isNullOrUndefined(height)) {
    return DEFAULT_HEADER_BANNER_HEIGHT; //250
  }
  return height;
};

const getBannerStyle = (banner: IMeasuredAdConfig | undefined, isMobile: boolean): CSSProperties => {
  const minHeight = getDefaultBannerHeight(banner, isMobile);
  const maxHeight = banner?.maxHeight ?? minHeight;
  return { minHeight, maxHeight, height: '100%' };
};

export const BannerAd = ({ bannerConfig }: { bannerConfig?: IMeasuredAdConfig }) => {
  const isMobile = useContext(ColumnLayoutContext) === '1-column';
  const bannerAdRef = useRef<HTMLElement>(null);
  /** We show hide banner now as we need the banner child to update when ads are ready to init */
  const showHeaderBanner = getDefaultBannerHeight(bannerConfig, isMobile) > 0;

  if (showHeaderBanner) {
    return (
      <header className="Header" ref={bannerAdRef} style={{ display: showHeaderBanner ? '' : 'none' }}>
        <BannerAdCore isMobile={isMobile} slotConfig={bannerConfig} />
      </header>
    );
  }
};

const BannerAdCore = ({ isMobile, slotConfig }: { isMobile: boolean; slotConfig: IMeasuredAdConfig | undefined }) => {
  const slotStyles = getBannerStyle(slotConfig, isMobile);
  const { bannerAd } = useContext(AdDomReadyContext);

  return (
    <section className="BannerAd" style={slotStyles}>
      <AdvertErrorBoundary>
        <AdvertFuse
          fuseTag={slotConfig?.fuseTag}
          adUnitPath={slotConfig?.adUnitPath}
          targeting={slotConfig?.targeting}
          origin="adv-Banner"
          timerDOMReady={bannerAd.adDomReady}
          timerFuseRequest={bannerAd.adRequest}
          timerFuseResponse={bannerAd.adResponse}
        />
      </AdvertErrorBoundary>
    </section>
  );
};
